import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { Icon } from '../ui/Icon';
import { CountdownTimer } from './CountdownTimer';
export function Hero() {
  useEffect(() => {
    // Load Wistia scripts
    const script1 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/player.js';
    script1.async = true;
    document.head.appendChild(script1);
    const script2 = document.createElement('script');
    script2.src = 'https://fast.wistia.com/embed/d25yuoo8og.js';
    script2.async = true;
    script2.type = 'module';
    document.head.appendChild(script2);
    // Add Wistia styles
    const style = document.createElement('style');
    style.textContent = `
      wistia-player[media-id='d25yuoo8og']:not(:defined) { 
        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/d25yuoo8og/swatch'); 
        display: block; 
        filter: blur(5px); 
        padding-top: 56.25%; 
      }
    `;
    document.head.appendChild(style);
    return () => {
      // Cleanup
      if (document.head.contains(script1)) document.head.removeChild(script1);
      if (document.head.contains(script2)) document.head.removeChild(script2);
      if (document.head.contains(style)) document.head.removeChild(style);
    };
  }, []);
  return <section className="relative bg-black text-white overflow-hidden pt-16 sm:pt-20" data-id="element-82">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black opacity-90" data-id="element-83" />

      {/* Orange accent lines */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-orange-500 to-transparent" data-id="element-84" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 py-4 sm:py-10 lg:py-16" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-86">
          {/* Black Friday Badge */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2
        }} className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-orange-600 text-black px-3 sm:px-6 py-1.5 sm:py-3 rounded-full font-bold text-xs sm:text-sm uppercase tracking-wider mb-3 sm:mb-8" data-id="element-87">
            <Icon name="fire" size={16} className="sm:w-5 sm:h-5" data-id="element-88" />
            Promo de Navidad
          </motion.div>

          {/* Main Headline - Optimized for mobile */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="text-2xl sm:text-4xl md:text-6xl lg:text-7xl font-extrabold leading-tight mb-3 sm:mb-10" data-id="element-89">
            Cómo Generar Tus Primeros $10,000 Online … Usando Info-Commerce y la
            Nueva Ola de IA
          </motion.h1>

          {/* Countdown Timer - More compact on mobile */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.35
        }} className="mb-4 sm:mb-10" data-id="element-90">
            <CountdownTimer data-id="element-91" />
          </motion.div>

          {/* Wistia Video */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="max-w-4xl mx-auto mb-6 sm:mb-10 px-2" data-id="element-92">
            <div className="relative rounded-xl overflow-hidden shadow-2xl border-2 border-orange-500/20" data-id="element-93">
              <wistia-player media-id="d25yuoo8og" aspect="1.7777777777777777" className="w-full" data-id="element-94" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.45
        }} className="text-base sm:text-xl md:text-2xl text-gray-300 mb-2 sm:mb-4" data-id="element-95">
            Acceso a las Grabaciones de Septiembre & Octubre
          </motion.div>

          {/* Subheadline - Smaller on mobile */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="text-lg sm:text-2xl md:text-3xl lg:text-4xl font-bold text-orange-400 mb-4 sm:mb-8 leading-tight max-w-4xl mx-auto px-2" data-id="element-96">
            Domina Info Commerce + IA y Aprende a Crear, Lanzar y Escalar
            Ofertas Digitales en DÍAS… No en Meses
          </motion.p>

          {/* Value Prop - More compact on mobile */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="text-sm sm:text-lg md:text-xl text-gray-300 mb-6 sm:mb-12 max-w-3xl mx-auto leading-relaxed px-2" data-id="element-97">
            <p className="mb-2 sm:mb-4" data-id="element-98">
              ¿Y si te dijera que puedes aprender todo mi sistema de
              InfoCommerce + IA…
            </p>
            <p className="font-semibold text-white" data-id="element-99">
              el mismo que mis estudiantes usan para generar desde sus primeros
              $3,000 en 7 días hasta cientos de miles de dólares, por una
              fracción ridícula del precio real?
            </p>
          </motion.div>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.7
        }} className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 px-4" data-id="element-100">
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/xGRln" className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-300 bg-gradient-to-r from-[#FF6B35] to-[#F7931E] rounded-full hover:shadow-2xl hover:shadow-orange-500/50 hover:scale-105" data-id="element-101">
              <span className="relative z-10" data-id="element-102">¡QUIERO MI ACCESO AHORA!</span>
            </a>
          </motion.div>

          {/* Price Highlight - More compact on mobile */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} className="mt-4 sm:mt-8 text-center px-4" data-id="element-103">
            <div className="inline-block bg-gray-900 border border-orange-500/30 rounded-lg px-4 sm:px-8 py-2 sm:py-4" data-id="element-104">
              <div className="text-gray-400 line-through text-sm sm:text-lg mb-1" data-id="element-105">
                $997 USD
              </div>
              <div className="text-2xl sm:text-4xl font-extrabold text-orange-400" data-id="element-106">
                $497 USD
              </div>
              <div className="text-xs sm:text-sm text-gray-400 mt-1" data-id="element-107">
                Solo por Promo de Navidad
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* Bottom gradient */}
      <div className="absolute bottom-0 left-0 w-full h-20 sm:h-32 bg-gradient-to-t from-white to-transparent" data-id="element-108" />
    </section>;
}